import {NgModule} from '@angular/core';
import {CandleService} from './candle.service';
import {ChartSecurityService} from './chart-security.service';

@NgModule({
    providers: [
        CandleService,
        ChartSecurityService
    ]
})
export class ChartDatafeedModule {}
